import { combineReducers, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import cvReducer from '../components/CV/cvSlice';
import gestionConcursoReducer from '../components/Concursos/Gestion/gestionConcursoSlice';
import feedbackReducer from '../components/GlobalFeedback/feedbackSlice';
import commonSliceReducer from './commonSlice';

import storage from 'reduxjs-toolkit-persist/lib/storage';
import autoMergeLevel1 from 'reduxjs-toolkit-persist/es/stateReconciler/autoMergeLevel1';
import persistReducer from 'reduxjs-toolkit-persist/es/persistReducer';
import cronogramaReducer from './cronograma';
import comiteReducer from './comite';
import actasReducer from './actas';
import actoAdministrativoReducer from './actoAdministrativo';
import convocatoriaReducer from './convocatoria';
import denominacionesReducer from './denominaciones';
import inscripcionesReducer from './inscripciones';
import postulacionesPuestoReducer from '../components/Concursos/Gestion/TramitarConcursos/restPostulacionesPuesto';
import accionesConcursoReducer from '../components/Concursos/Commons/restAccionesConcurso';

/**
 * Manejo de estado global, utilizando redux-toolkit y redux-persist para mantener partes del estado entre refresh de paginas
 * Docs:
 *  redux-toolkit: https://redux-toolkit.js.org/introduction/getting-started
 *  redux-persist: https://github.com/rt2zz/redux-persist
 */

//Config para persistir la info de usuario. Ver también en Main.js el uso de cookies
const userPersistConfig = {
  key: 'common',
  storage,
  stateReconciler: autoMergeLevel1,
  whitelist: ['user'],
};

//Config para persistir datos del concurso seleccionado a la hora de tramitarlo (para permitir refresh de pagina)
const gestionConcursoPersistConfig = {
  key: 'gestionConcurso',
  storage,
  stateReconciler: autoMergeLevel1,
  whitelist: ['activo'],
};

const combinedReducers = combineReducers({
  cv: cvReducer,
  gestionConcurso: persistReducer(gestionConcursoPersistConfig, gestionConcursoReducer),
  feedback: feedbackReducer,
  common: persistReducer(userPersistConfig, commonSliceReducer),
  cronograma: cronogramaReducer,
  comite: comiteReducer,
  actas: actasReducer,
  actoAdministrativo: actoAdministrativoReducer,
  convocatoria: convocatoriaReducer,
  denominaciones: denominacionesReducer,
  inscripciones: inscripcionesReducer,
  postulacionesPuesto: postulacionesPuestoReducer,
  accionesConcurso: accionesConcursoReducer,
});

//Reducer raíz para procesar correctamente el deslogueo de usuario. Elimina la persistencia de usuario y resetea el estado
//global al inicial
const rootReducer = (state, action) => {
  if (action.type === 'global/common/logout/fulfilled') {
    state = undefined;
    localStorage.removeItem('persist:common'); //Elimino la persistencia del usuario en storage
  }

  return combinedReducers(state, action);
};

export default configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: false,
  }),
});
